'use client'
import { create } from 'zustand'

import type { CachedPins } from '@/components/map/components/viewModel'

interface GlobalCachedPinsState {
  cachedPins: CachedPins
  setCachedPins: (pins: CachedPins) => void
}

export const useGlobalCachedPins = create<GlobalCachedPinsState>((set) => ({
  cachedPins: {},
  setCachedPins: (pins) => set({ cachedPins: pins })
}))
